import { FormGroup, FormControl, Validators, AbstractControl, ValidatorFn } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { UsuarioService } from '../../../services/usuario/usuario.service';
import { Usuario } from '../../../models/usuario.model';
import { Component, OnInit } from '@angular/core';
import swal from 'sweetalert';
import decode from 'jwt-decode';


@Component({
  selector: 'app-perfil',
  templateUrl: './perfil.component.html',
  styleUrls: ['./perfil.component.css']
})
export class PerfilComponent implements OnInit {

  usuario: Usuario = new Usuario();
  subirImagen: File;
  imagenTemporal: string;
  correoUsuario: string;
  rolUsuario: string;


  formularioPerfil: FormGroup;

  cedulaValidadaConExito: boolean;

  constructor( public _usuarioService: UsuarioService, public toastr: ToastrService ) {

  }

  ngOnInit(): void {
    const token = localStorage.getItem('token');
    const tokenPayload = decode(token);
    //console.log(tokenPayload);
    this.obtenerUsuario(tokenPayload.usuario._id);

    this.formularioPerfil = new FormGroup({
      nombre: new FormControl('', [Validators.required, Validators.minLength(5), Validators.maxLength(80)]),
      apellido: new FormControl('', [Validators.required, Validators.minLength(5), Validators.maxLength(80)]),
      cedula: new FormControl('', [Validators.required, Validators.minLength(10), Validators.maxLength(10)]),
      movil: new FormControl('', [Validators.required, Validators.minLength(10), Validators.maxLength(10), Validators.pattern('[0-9]{0,10}')]),
      convencional: new FormControl('', [Validators.minLength(7), Validators.maxLength(7), Validators.pattern('[0-9]{0,7}')])
    });
  }

  obtenerUsuario(id: string){
    this._usuarioService.obtenerUsuario( id )
    .subscribe( usuarioObtenido => {
      this.formularioPerfil.get('nombre').setValue(usuarioObtenido.nombre)
      this.formularioPerfil.get('apellido').setValue(usuarioObtenido.apellido)
      this.formularioPerfil.get('cedula').setValue(usuarioObtenido.cedula)
      this.formularioPerfil.get('movil').setValue(usuarioObtenido.movil.substr(4,13).replaceAll(' ', ''))

      if(usuarioObtenido.convencional !== undefined){
        this.formularioPerfil.get('convencional').setValue(usuarioObtenido.convencional.substr(2,9).replaceAll(' ', ''))
      }else{
        this.formularioPerfil.get('convencional').setValue(usuarioObtenido.convencional)
      }

      this.usuario._id = usuarioObtenido._id;
      this.correoUsuario = usuarioObtenido.nombre;
      this.rolUsuario = usuarioObtenido.rol;

      if(usuarioObtenido.cedula != undefined){

        this.validarcedula(this.formularioPerfil.get('cedula'))
      }

     //console.log('visita: '+this.visitas.inmueble.nombre );
    },
    error => {
      //console.log('Error al obtener usuario');
    });
  }

  ActualizarInformacionPerfil() {

   /* if(usuario.nombre.trim() === ''){
      this.toastr.warning('Debes ingresar tus nombres');
      return;
    }
    if (usuario.nombre.length < 3) {
      this.toastr.warning('El nombre debe tener mínimo 3 caracteres');
      return;
    }
    if (usuario.nombre.length > 80) {
      this.toastr.warning('Excede el número de caracteres permitidos');
      return;
    }
    if(usuario.apellido.trim() === ''){
      this.toastr.warning('Debes ingresar tus apellidos');
      return;
    }
    if (usuario.apellido.length < 3) {
      this.toastr.warning('El nombre debe tener mínimo 3 caracteres');
      return;
    }
    if (usuario.apellido.length > 80) {
      this.toastr.warning('Excede el número de caracteres permitidos');
      return;
    }
    if(usuario.movil.trim() === '' || (usuario.movil.length > 0 && usuario.movil.length < 10)){
      //this.toastr.warning('Debes ingresar tu número de celular');
      return;
    }
    if(usuario.cedula.trim() === ''){
      this.toastr.warning('Debes ingresar tu número de cédula');
      return;
    }
    if(!this.validarcedula(usuario.cedula)){
      this.toastr.warning('El número de cédula es inválido');
      return;
    }
    this.usuario.nombre = usuario.nombre;
    this.usuario.apellido = usuario.apellido;
    this.usuario.movil = usuario.movil;
    this.usuario.convencional = usuario.convencional;
    this.usuario.cedula = usuario.cedula;*/



    if(this.formularioPerfil.invalid){
      return;
    }
    this.usuario.nombre = this.formularioPerfil.value.nombre;
    this.usuario.apellido = this.formularioPerfil.value.apellido;
    this.usuario.movil = '+593'+this.formularioPerfil.value.movil;
    this.usuario.cedula = this.formularioPerfil.value.cedula;
    this.usuario.convencional = '07'+this.formularioPerfil.value.convencional;

    //.log(this.usuario)
    if(this.cedulaValidadaConExito){
      this._usuarioService.actualizarUsuario(this.usuario).subscribe(resp => {
        if(resp){
          swal(
            'Actualización exitosa',
            'Se ha actualizado su información correctamente',
            'success'
          );
        }
      });

    }else{
      this.toastr.warning('El número de cédula no es válido');
    }
    this.usuario.movil = this.usuario.movil.substr(4,13)
    this.usuario.convencional = this.usuario.convencional.substr(2,9)
  }
  validarcedula(cedula){
    if(cedula === undefined){
      cedula.value = ""
    }
    //console.log(cedula.value)
    let suma = 0;
    let digitoComparador=0;
    let resultado=0;
    //se recorre los primeros 9 dígitos
    for (let i = 0; i < (cedula.value.length-1); i++) {
      //convierto a entero cada dígito de la cédula
      let digito = parseInt(cedula.value[i]);
      //valido si cada posición es par
      if(i % 2 === 0){
          //multiplico el dígito por dos
          digito = digito * 2;
          //si el dígito excede de 9, le resto 9 a ese número
            if(digito > 9){
              digito = digito - 9;
            }
          }
          //guardo la suma total
          suma = suma+digito;
        }
        //encuentro el número próximo al cual le saco el módulo en base 10
        //y su residuo sea igual a cero
        if((suma % 10) !== 0){
          //resto el total de la suma
          resultado = 10 - (suma%10);
          digitoComparador = parseInt(cedula.value[9]);
        }
        //console.log(suma)
        //si el dígito verificdor o comparador es igual al resultado, entonces es una cédula válida
        if(digitoComparador === resultado){
         //console.log('Cédula válida')
          this.cedulaValidadaConExito = true;
          return true;
        }
        this.cedulaValidadaConExito = false;
       // console.log('Cédula inválida'+ this.cedulaValidadaConExito)
          return false;
 }
  seleccionarImagen(archivo: File) {
    if (!archivo) {
      this.subirImagen = null;
      return;
    }
    if (archivo.type.indexOf('image') < 0) {
      swal('Sólo imágenes', 'El archivo seleccionado no es una imágen', 'error');
      this.subirImagen = null;
      return;
    }
    this.subirImagen = archivo;

    let reader = new FileReader();
    let urlImagenTemporal = reader.readAsDataURL(archivo);

    reader.onloadend = () => this.imagenTemporal = reader.result as string;
  }

  cambiarImagen() {
    this._usuarioService.actualizarImagen(this.subirImagen, this.usuario._id);

  }

  regresarPagina(){
    window.history.back();
  }

  get nombre(){ return this.formularioPerfil.get('nombre');}
  get apellido(){ return this.formularioPerfil.get('apellido');}
  get cedula(){ return this.formularioPerfil.get('cedula');}
  get movil(){ return this.formularioPerfil.get('movil');}
  get convencional(){ return this.formularioPerfil.get('convencional');}


}
